<template>
  <v-container :class="{ 'pt-0': !showInfo }" fluid>
    <Navbar
      :hasBackButton="true"
      @backBtnClicked="$router.go(-1)"
      :title="`Pedido #${id}`"
    >
      <template slot="actions">
        <v-btn
          icon
          @click="showInfo = !showInfo"
        ><v-icon>{{ showInfoIcon }}</v-icon>
        </v-btn>
      </template>
    </Navbar>
    <v-row>
      <v-col v-if="error">
        <p class="text-center red--text font-weight-bold">{{ error }}</p>
      </v-col>
      <v-col v-if="showInfo" cols="12" class="py-0">
        <v-card outlined v-if="pedido">
          <v-card-text>
            <div>
              <p class="ma-0 font-weight-bold">Cliente: {{ pedido.cliente }}</p>
              <p class="ma-0 font-weight-bold">Emissão: {{ pedido.emissao | dateMonthYear }}</p>
              <p class="ma-0 font-weight-bold">Total Produtos: {{ pedido.itens.length }}</p>
              <p class="ma-0 font-weight-bold" :class="pedido.qtde_realizada === pedido.qtde_prevista ? 'green--text' : 'red--text'">Total Realizado: {{ pedido.qtde_realizada }}</p>
              <p class="ma-0 font-weight-bold green--text">Total Previsto: {{ pedido.qtde_prevista }}</p>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" class="pa-0" v-if="pedido && pedido.itens.length">
        <v-subheader class="font-weight-bold">Produtos</v-subheader>
        <v-list
          class="pa-0"
          three-line
          v-if="pedido.itens.length"
        >
          <v-list-item
            v-for="(item, i) in pedido.itens"
            :key="i"
            @click="$router.push({ name: 'PedidoColetas', params: { id: pedido.id_saida, idProduto: item.id_produto }})"
            class="pr-0"
          >
            <v-list-item-content :class="i !== pedido.itens.length -1 ? 'pb-0' : ''">
              <v-col cols="10" md="6" class="pa-0">
                <v-list-item-title class="body-2">
                  <v-icon small>mdi-pound</v-icon>
                  {{ item.id_produto }}
                </v-list-item-title>
              </v-col>
              <v-col cols="10" md="6" class="pa-0">
                <v-list-item-title class="body-2">
                  <v-icon small>mdi-clipboard-text-outline</v-icon>
                  {{ item.descricao }}
                </v-list-item-title>
              </v-col>
              <v-col cols="12" md="6" offset-md="0" class="pa-0">
                <v-list-item-title class="caption">
                  <v-icon small>mdi-package-variant-closed</v-icon>
                  <span :class="textColor(item)">
                    {{ item.qtde_realizada }}</span> / 
                    <span class="green--text">
                      {{ item.qtde_prevista }}
                    </span>
                    {{ item.unidade }}
                </v-list-item-title>
              </v-col>
              <v-divider v-if="i !== pedido.itens.length - 1" :key="i"></v-divider>
            </v-list-item-content>
            <v-list-item-action class="ma-auto">
              <v-btn icon>
                <v-icon>mdi-arrow-right</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-col>
      <v-col cols="12" v-else-if="pedido && !pedido.itens.length">
        <p class="text-center font-weight-bold white py-3">Nenhum produto encontrado</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { pedidoService } from '@/services/pedidoService';
// import StatusIcon from '@/components/shared/StatusIcon';

export default {
  name: 'Pedido',
  props: ['id'],
  // components: {
  //   StatusIcon
  // },
  data: () => ({
    pedido: null,
    error: '',
    showInfo: false,
  }),
  computed: {
    showInfoIcon() {
      return this.showInfo ? 'mdi-chevron-up' : 'mdi-chevron-down';
    },
    // qtdePrevista() {
    //   if (this.pedido) return this.pedido.itens.reduce((acc, cur) => cur.qtde_prevista + acc, 0);
    //   return 0;
    // },
    // qtdeRealizada() {
    //   if (this.pedido) return this.pedido.itens.reduce((acc, cur) => cur.qtde_realizada + acc, 0);
    //   return 0;
    // }
  },
  methods: {
    textColor(item) {
      return item.qtde_realizada === item.qtde_prevista ? 'green--text' : 'red--text';
    },
    async fetchPedido() {
      try {
        const pedido = await pedidoService.getPedido(this.id);
        if (pedido) this.pedido = pedido;
        else this.error = 'Pedido não encontrado.';
      } catch (error) {
        this.error = 'Pedido não encontrado.';
        console.log(error);
      }
    }
  },
  created() {
    this.fetchPedido();
  }
}
</script>

<style>

</style>